import { getShouldDisplayFees } from '../getShouldDisplayFees/getShouldDisplayFees';
import { getShouldDisplayTaxes } from '../getShouldDisplayTaxes/getShouldDisplayTaxes';

interface GetPriceDisplayStatus {
    regionCode?: string;
}

export type PriceDisplayStatus = 'fees' | 'taxes' | 'both' | 'none';

export const getPriceDisplayStatus = ({ regionCode = '' }: GetPriceDisplayStatus): PriceDisplayStatus => {
    const shouldDisplayFees = getShouldDisplayFees({ regionCode });
    const shouldDisplayTaxes = getShouldDisplayTaxes({ regionCode });

    if (shouldDisplayFees && shouldDisplayTaxes) {
        return 'both';
    }

    if (shouldDisplayFees) {
        return 'fees';
    }

    if (shouldDisplayTaxes) {
        return 'taxes';
    }

    return 'none';
};
